// extracted by mini-css-extract-plugin
module.exports = {"container":"LegalButtons_container__mJ1Un","button":"LegalButtons_button__38OrJ","buttonText":"LegalButtons_buttonText__1rqh6"};